$(function() {
    $("time").each(function() {
        var el = $(this);
        var dt = moment(el.attr("datetime"));

        // set the locale if supplied
        if (typeof (el.attr("data-locale")) !== 'undefined') {
            dt.locale(el.data("format"));
        }
        
        // rpelace the inner text with the date as formatted text  
        if (typeof (el.attr("data-format")) !== 'undefined') {
            el.text(dt.format(el.data("format")));
        } else {
            el.text(dt.format());
        }

        if (typeof (el.attr("data-delta")) !== 'undefined') {

            var text = dt.fromNow();
     
            
            // text string formatting
            if (typeof (el.attr("data-delta-textprefix")) !== 'undefined') {
                text = el.data("delta-textprefix") + text; 
            }
            if (typeof (el.attr("data-delta-textsuffix")) !== 'undefined') {
                text += el.data("delta-textsuffix"); 
            }
            
            /**
             * Allow color coding of the delta data.
             * 
             * puts CSS class on element, e.g.
             * 
             * "time-delta years years3 negative" indicates: 
             *             ^- over a year difference, 
             *                   ^- the period is 3 years, 
             *                           ^- and it's in the past so it's 3 years ago
             * 
             * This allows fine-grained colour control via CSS.
             */
            var now = moment();
            var htmlClass = '';
            if (typeof (el.attr("data-delta-class")) !== 'undefined') {
                htmlClass = el.data("delta-class");
            }
            
            var diffDays = dt.diff(now, 'days');
            var diffMonths = dt.diff(now, 'months');
            var diffYears = dt.diff(now, 'years');
            if (diffYears != 0) { 
                htmlClass += 'years years'+ (Math.abs(diffYears));
                if (diffYears < 0) {
                    htmlClass += ' negative';
                }
            } else if (diffMonths != 0) {
                htmlClass += 'months months'+ (Math.abs(diffMonths));
                if (diffMonths < 0) {
                    htmlClass += ' negative';
                }
            } else if (diffDays != 0) {
                htmlClass += 'days days' + (Math.abs(diffDays));
                if (diffDays < 0) {
                    htmlClass += ' negative';
                }  
            }
            
            
            // add another HTML element
            el.after(' <span class="' + htmlClass + '">' + text + '</span>');
        }

    });
});